const IMAGE_TYPE = 'wix-draft-plugin-image';
const IMAGE_TYPE_LEGACY = 'IMAGE';
const getDefaultComponentData = ()=>({
        config: {
            alignment: 'center',
            size: 'content',
            showTitle: true,
            showDescription: true
        }
    });
export { IMAGE_TYPE_LEGACY, IMAGE_TYPE, getDefaultComponentData };
